const files = require.context('./interface', false, /\.js$/)
let modules = {}
files.keys().forEach(key => {
  modules = Object.assign(files(key).default, modules)
})
export default modules